import { useState, useEffect, useCallback } from 'react';

/**
 * Зворотний відлік у секундах (кнопка "Надіслати повторно" у 2FA-модалці).
 * Тік раз на секунду, інтервал чиститься на нулі та при unmount.
 *
 * @param {number} initialSeconds стартове значення відліку
 * @returns {{ seconds: number, isRunning: boolean, restart: (s?: number) => void }}
 */
export const useCountdown = (initialSeconds = 60) => {
    const [seconds, setSeconds] = useState(initialSeconds);

    useEffect(() => {
        if (seconds <= 0) return;
        const tick = setInterval(() => {
            setSeconds(prev => (prev > 0 ? prev - 1 : 0));
        }, 1000);
        return () => clearInterval(tick);
    }, [seconds > 0]);

    const restart = useCallback((newSeconds = initialSeconds) => {
        setSeconds(newSeconds);
    }, [initialSeconds]);

    return { seconds, isRunning: seconds > 0, restart };
};

export default useCountdown;
